import * as React from "react";
import "../../Styles/RiskViews.scss";
import { Grid, GridColumn, GridDetailRow } from "@progress/kendo-react-grid";
import MitigationNameCell from "../Tenant/Component/MitigationNameCell";
import MitigationStatus from "../Tenant/Component/MitigationStatus";

export class CopyExpandActivityDetails extends GridDetailRow {
  constructor(props) {
    super(props);
    this.state = {};
  }

  approvedCell = (event) => {
    return <td>{event.dataItem.isApproved ? "Yes" : "No"}</td>;
  };
  statusCell = (event) => {
    return <td>{event.dataItem.isClosed ? "Closed" : "Open"}</td>;
  };
  onEditCell = () => {};
  render() {
    const data = this.props.dataItem.taskActions||[];
      return (
        <div className="riskReportMitigation">
          <Grid data={data} reorderable resizable>
            <GridColumn
              field="isApproved"
              title="Approved"
              width="80px"
              cell={this.approvedCell}
            />
            <GridColumn
              field="taskActionNumber"
              title="Activity Number"
              width="100px"
              locked={true}
            />
            <GridColumn
              field="taskActionTitle"
              title="Activity Title"
              width="120px"
              locked={true}
              
            />
            <GridColumn
              field="taskActionDescription"
              title="Activity Description"
              width="150px"
             
            />
            
            <GridColumn
              field="isClosed"
              title="Status"
              width="80px"
              editor="boolean"
              cell={this.statusCell}
            />
          </Grid>
        </div>
      );
  }
}
